module.exports = __webpack_public_path__ + "media/images/screener_intro-2bde16ed.png";